import React from 'react';
import styled from 'styled-components';
import * as cons from '../../constants';
export function OrLine() {
    return (React.createElement(OrLineWrapper, null,
        React.createElement(Line, null),
        React.createElement(Text, null, "or"),
        React.createElement(Line, null)));
}
const OrLineWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 18px 0px;
`;
const Line = styled.div `
  width: 42%;
  height: 1px;
  background-color: ${cons.COLOR_GRAY_1};
`;
const Text = styled.div `
  color: ${cons.COLOR_GRAY_3};
`;
